import { useState, useCallback, useMemo } from 'react';
import useApiFetch from '@/hooks/useApiFetch';
import candidatesServices, { NewCandidateResponse } from '@/services/candidates';
import { FetchApiIds } from '@/types';
import NewCandidatesTableComponent from './NewCandidatesTable.component';
import * as Styles from './NewCandidatesTable.styles';

const NewCandidatesTable = (): JSX.Element => {
  const [selectedFilter, setSelectedFilter] = useState('Today');

  const newCandidatesResponse = useApiFetch<NewCandidateResponse[]>(
    FetchApiIds.GET_NEW_CANDIDATES,
    candidatesServices.getNewCandidates
  );

  const onSelectFilter = useCallback((value: string): void => {
    setSelectedFilter(value);
  }, []);

  const filterOptions = useMemo(() => {
    const response = newCandidatesResponse.data ?? [];

    return response.map((filter) => {
      return {
        label: (
          <Styles.FilterLabelContainer>
            <Styles.FilterLabelCountText>{filter.persons.length}</Styles.FilterLabelCountText>
            <p>{filter.label}</p>
          </Styles.FilterLabelContainer>
        ),
        value: filter.label,
        candidates: filter.persons,
        isActived: filter.label === selectedFilter,
      };
    });
  }, [newCandidatesResponse.data, selectedFilter]);

  const filteredCandidates = filterOptions.find((filter) => !!filter.isActived)?.candidates ?? [];

  return (
    <NewCandidatesTableComponent
      isLoading={newCandidatesResponse.isLoading}
      onSelectFilter={onSelectFilter}
      periodOptions={filterOptions}
      title="New"
      tooltipMessage="This table displays all new candidates created on the selected date."
      filteredCandidates={filteredCandidates}
    />
  );
};

export default NewCandidatesTable;
